import React, { useEffect, useState } from "react";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import { useDispatch } from "react-redux";
import { AddAttachment } from "../../../Redux/Reducers/ReportStage/StartProgressReport";

function AttachedAccreditationReport(props) {
    const [ApprovalAttachmentPath, setApprovalAttachmentPath] = useState();
    const [fileChange, setFileChange] = useState(0);
  const dispatch = useDispatch();

  const addedAttachment = (ApprovalAttachmentPath)=>{
    const formData = new FormData();
    formData.append("ReportStageId", props.reportStageId);
    formData.append("ApprovalAttachmentPath", ApprovalAttachmentPath);
    dispatch(AddAttachment(formData));
  }

useEffect(()=>{
  if(props?.reportStage?.approvalAttachmentPath!=null){

    props.setNewAddedAttachment(props?.reportStage?.approvalAttachmentPath)
  }
},[])
console.log(props?.reportStage?.reportStageStatusId=="8d983649-264c-4e4f-883f-c757840c97a3","ssssssssdwdwd");

  return (
    <>
    {
      props?.reportStage?.reportStageStatusId?<>
      
      <div style={{ marginTop: "20px" }}>
      <label style={{ margin: "30px" }}>
        مرفق محضر الاعتماد
        <span className="star" style={{ color: "red" }}>
          *
        </span>
      </label>
      <div style={{ margin: "30px", width: "50%" }}>
        <AttachmentASFH
          id="NewAddedAttachment"
          title="إضافة مرفق"
          show={!(props?.reportStage?.reportStageStatusId==="8d983649-264c-4e4f-883f-c757840c97a3")}
          clear={false}
          disabled={props?.reportStage?.reportStageStatusId=="8d983649-264c-4e4f-883f-c757840c97a3"}
          AttachementType="NewAddedAttachment"
          singleFile={props?.reportStage?.approvalAttachmentPath}
          readOnly={true}
          onChange={(e) => {
            props.setNewAddedAttachment(e.target.files[0])
            setFileChange(fileChange + 1);
            addedAttachment(e.target.files[0]);
            // setApprovalAttachmentPath(e.target.files[0]);
          }}
          // showValidationMessage={
          //   state.BudgetItemsValidate?.includes("NewAddedAttachment") || false
          // }
          // validationMessage="يرجى تعبئة هذا الحقل"
        />
      </div>
    </div>
      </>:<></>
    }
    
    </>
    
  );
}

export default AttachedAccreditationReport;
